<template>
    <div>
        <FilterStats />
        <ThemeFilterRefinementList
            title="Product Type"
            attribute="product_type"
            :sort-by="['name']"
            operator="or"
            :expanded-default="true"
            :mobile-menu-open="mobileMenuOpen"
        />

        <ThemeFilterRefinementList
            title="Theme"
            attribute="theme_group"
            :sort-by="['name']"
            operator="or"
            :expanded-default="true"
            :mobile-menu-open="mobileMenuOpen"
        />

        <ThemeFilterRefinementList
            title="Capacity"
            attribute="capacity"
            :sort-by="['name']"
            operator="or"
            :mobile-menu-open="mobileMenuOpen"
        />

        <ThemeFilterRefinementList
            title="Eco-friendly"
            attribute="eco_friendly"
            :sort-by="['name']"
            operator="or"
            :mobile-menu-open="mobileMenuOpen"
        />

        <ThemeFilterRefinementList
            title="Minimum Order Quantity"
            attribute="minimum"
            :sort-by="sortNumeric"
            operator="or"
            :mobile-menu-open="mobileMenuOpen"
        />
    </div>
</template>

<script setup lang="ts">
import ThemeFilterRefinementList from '~/components/page-building/design-lab-pick-your-product/components/ThemeFilterRefinementList.vue';
import FilterStats from '~/components/page-building/algolia/FilterStats.vue';
defineProps<{
    mobileMenuOpen?: boolean;
}>();

const sortNumeric = (a: string, b: string) => {
    return parseInt(a) - parseInt(b);
};
</script>
